import { render, staticRenderFns } from "./CategoryParamOptionsModal.vue?vue&type=template&id=0fbf8561&scoped=true"
import script from "./CategoryParamOptionsModal.vue?vue&type=script&lang=js"
export * from "./CategoryParamOptionsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbf8561",
  null
  
)

export default component.exports